// CORE-538 — FE side of the BE auth error-code contract (CORE-515).
// /api/auth/register and social login return { code, message }; map the
// stable machine codes to localized copy (auth namespace) and let callers
// fall back to the raw BE message / a generic when the code is unknown.
// CORE-576 extended the same contract to /api/auth/login.
import type { ApiError } from '../../types/auth';

const CODE_TO_KEY: Record<string, string> = {
  INVALID_EMAIL: 'apiErrors.invalidEmail',
  EMAIL_ALREADY_EXISTS: 'apiErrors.emailAlreadyExists',
  WEAK_PASSWORD: 'apiErrors.weakPassword',
  REGISTRATION_FAILED: 'apiErrors.registrationFailed',
  RATE_LIMIT_EXCEEDED: 'apiErrors.rateLimitExceeded',
  INVALID_SOCIAL_TOKEN: 'apiErrors.invalidSocialToken',
  // CORE-576 — login codes. INVALID_CREDENTIALS covers both «no such email»
  // and «wrong password»; the BE keeps them indistinguishable on purpose.
  INVALID_CREDENTIALS: 'apiErrors.invalidCredentials',
  EMAIL_NOT_CONFIRMED: 'apiErrors.emailNotConfirmed',
  ACCOUNT_BLOCKED: 'apiErrors.accountBlocked',
  // CORE-1404 — согласие и возраст при регистрации.
  CONSENT_REQUIRED: 'apiErrors.consentRequired',
  AGE_REQUIRED: 'apiErrors.ageRequired',
  AGE_NOT_ALLOWED: 'apiErrors.ageNotAllowed',
};

/** i18n key (auth namespace) for a known auth error code, else null.
 *  HTTP 429 maps to RATE_LIMIT_EXCEEDED even when the body carries no code. */
export function authErrorKey(
  err: Pick<ApiError, 'code' | 'status'> | null | undefined,
): string | null {
  if (!err) return null;
  if (err.code && CODE_TO_KEY[err.code]) return CODE_TO_KEY[err.code];
  if (err.status === 429) return CODE_TO_KEY.RATE_LIMIT_EXCEEDED;
  return null;
}
